var _clipPath, _linearGradient, _linearGradient2, _linearGradient3, _clipPath2, _linearGradient4, _linearGradient5, _linearGradient6, _clipPath3, _linearGradient7, _linearGradient8, _radialGradient, _clipPath4, _linearGradient9, _radialGradient2, _radialGradient3, _radialGradient4, _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "1 1 190 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 88
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 110.87,
    x2: 52.54,
    y1: 164.5,
    y2: 130.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1a237e",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 30.43,
    x2: 86.54,
    y1: 74.4,
    y2: 41.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1a237e",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 118.57,
    x2: 54.58,
    y1: 169.11,
    y2: 131.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1a237e",
    stopOpacity: 0
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#R"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1a237e",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 121.86,
    x2: 136.55,
    y1: 49.8,
    y2: 114.13,
    xlinkHref: "#a"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 121.87,
    x2: 136.29,
    y1: 50.07,
    y2: 113.01,
    xlinkHref: "#a"
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 29.34,
    x2: 81.84,
    y1: 75.02,
    y2: 44.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1a237e",
    stopOpacity: 0
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 92.18,
    cy: 55.95,
    r: 84.08,
    xlinkHref: "#b"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.36 116L96 56h88V8H21.97v40.34"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 8,
    x2: 130.65,
    y1: 104.24,
    y2: 104.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4b400",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f2a700",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f19800",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f09300",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 21.87,
    cy: 48.52,
    r: 78.04,
    xlinkHref: "#b"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 95.84,
    cy: 96.14,
    r: 87.87,
    xlinkHref: "#b"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 34.29,
    cy: 32.01,
    r: 176.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#5e97f6",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3367d6",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#e)",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.15,
    d: "M62.3 115.65l-39.83-68.3-.58 1 39.54 67.8z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5e97f6",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.15,
    d: "M129.84 117.33l-.83-.48L90.62 184h1.15l38.1-66.64z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#a1c2fa",
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#h)",
    xlinkHref: "#S"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#a1c2fa",
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#i)",
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#3367d6",
    xlinkHref: "#T"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#k)",
    xlinkHref: "#T"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M96 56v20.95L174.4 56z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#m)",
    clipPath: "url(#n)",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M21.97 48.45l57.25 57.24L61.36 116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M91.83 183.9l20.96-78.2 17.86 10.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 40,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 32,
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.2,
    d: "M96 55a40 40 0 00-40 40v1a40 40 0 0140-40h88v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M130.6 116A39.96 39.96 0 0196 136a39.97 39.97 0 01-34.61-20h-.04L8 24.48v1L61.36 117h.04a39.94 39.94 0 0069.21 0h.05v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    d: "M97 56c-.17 0-.33.02-.5.03a39.98 39.98 0 010 79.94c.17 0 .33.03.5.03a40 40 0 000-80z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M131 117.33a39.72 39.72 0 003.5-32.05 39.72 39.72 0 01-3.87 30.69l.02.04-38.87 68h1.16l38.1-66.64zM96 9a88 88 0 0187.99 87.5l.01-.5A88 88 0 008 96v.5A88 88 0 0196 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a237e",
    fillOpacity: 0.15,
    d: "M96 183a88 88 0 0087.99-87.5l.01.5A88 88 0 018 96l.01-.5A88 88 0 0096 183z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 88,
    fill: "url(#q)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M21.97 8v108h39.4L96 56h88V8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromium);
export default __webpack_public_path__ + "static/media/chromium.4da11364f9984c4f033bfe5a0619fb72.svg";
export { ForwardRef as ReactComponent };